import { useState } from "react";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import { PAYMENT_LINK_APIS } from "features/PaymentLinks/constants/PaymentLinks.apis";
import { isNumericListingId } from "utils/listing/listingUtils";
import { INR } from "features/Listings/Listings.constants";

export const useQrModal = (record, onClose) => {
  const [selectedType, setSelectedType] = useState(null);
  const [apiQrUrl, setApiQrUrl] = useState(null);
  const [apiQrImageUrl, setApiQrImageUrl] = useState(null);
  const [error, setError] = useState(null);

  const { mutateAsync, isLoading } = useCustomMutation({
    url: PAYMENT_LINK_APIS.generate_qr,
  });

  const handleSelectType = async (type) => {
    setSelectedType(type);
    setError(null);
    setApiQrUrl(null);
    setApiQrImageUrl(null);
    try {
      let payload = {};
      if (record?.dynamic_link_id) {
        payload = {
          dynamic_link_id: record.dynamic_link_id,
          qr_type: type,
        };
      } else {
        const rawListingId = record?.listing_id || record?.id;

        const isNumeric = isNumericListingId(rawListingId);

        const listingId = isNumeric ? Number(rawListingId) : undefined;

        const linkPrice = Number(
          record?.link_price || record?.price_per_head || record?.price || 0
        );
        const currency = record?.currency_name || record?.currency || INR;
        const title = record?.title || record?.name || "QR payment link";
        const expiryDate = record?.expiry_date || record?.expiry || null;
        const metadata = { ihf_included: false };

        payload = {
          ...(listingId !== undefined && { listing_id: listingId }),
          link_price: linkPrice,
          currency,
          title,
          expiry_date: expiryDate,
          metadata,
          qr_type: type,
        };
      }

      const responseData = await mutateAsync(payload);
      const url = responseData?.payment_link;
      const imageUrl = responseData?.qr_image_url;

      if (imageUrl) {
        setApiQrImageUrl(imageUrl);
        setApiQrUrl(url || "");
      } else {
        throw new Error("QR Image URL not found in response");
      }
    } catch (err) {
      console.error("Error generating QR code:", err);
      setApiQrUrl(null);
      setApiQrImageUrl(null);
      setError("Failed to load QR code. Please try again.");
    }
  };

  const handleCloseModal = () => {
    setSelectedType(null);
    setApiQrUrl(null);
    setApiQrImageUrl(null);
    setError(null);
    onClose();
  };

  return {
    selectedType,
    apiQrUrl,
    apiQrImageUrl,
    isLoading,
    error,
    handleSelectType,
    handleCloseModal,
  };
};
